import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PermissionWrapper from "../../../permission_advance/PermissionWrapper";
import ServiceUsersOptionsBlocks from "../../../components/user-detail/ServiceUsersOptionsBlocks";
import Layout from "../../../components/layouts/Layout";
import UserDetailHeader from "../../../components/user-detail/UserDetailHeader";

function CarePlanning() {
  const navigate = useNavigate();
  const handleRowClickCarePlanning = (url) => {
    navigate(url);
  };
  return (
    <>
      <Layout pageTitleText="Care Planning Reports">
        <UserDetailHeader backToReports={true} />
        <h1>Under Construction</h1>
      </Layout>
    </>
  )
}

export default CarePlanning